/**
 * EmailVerificationBanner — shown when the user's email is unverified.
 * Sits below the trial banner. Dismissible per session but re-appears on reload.
 */
import React, { useState } from 'react';
import './EmailVerificationBanner.css';

export default function EmailVerificationBanner({ user }) {
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      const token = localStorage.getItem('oakdesk_token') || sessionStorage.getItem('oakdesk_token') || '';
      await fetch('/auth/resend-verification', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      setSent(true);
    } catch (_) {
      setSent(true); // show success regardless — don't expose SMTP issues to user
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="evb-banner">
      <div className="evb-banner__inner">
        <span className="evb-banner__icon">✉️</span>
        <span className="evb-banner__text">
          <strong>Verify your email address</strong> to ensure uninterrupted access.
          {' '}We sent a link to <strong>{user.email}</strong>.
        </span>
        <div className="evb-banner__actions">
          {sent ? (
            <span className="evb-banner__sent">✓ Verification email sent</span>
          ) : (
            <button className="evb-btn" onClick={resend} disabled={sending}>
              {sending ? 'Sending…' : 'Resend email'}
            </button>
          )}
          <button className="evb-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">✕</button>
        </div>
      </div>
    </div>
  );
}
